import { initialStoreUser, StoreUser } from "./user/types";
import { initialStoreLoading, StoreLoading } from "./loading/types";
import {
  initialStoreNotification,
  StoreNotification,
} from "./notification/types";
import { initialStoreModal, StoreModal } from "./modal/types";

export interface StoreState {
  loading: StoreLoading;
  modal: StoreModal;
  notification: StoreNotification;
  user: StoreUser;
}

export const initialStore: StoreState = {
  loading: initialStoreLoading,
  modal: initialStoreModal,
  notification: initialStoreNotification,
  user: initialStoreUser,
};
